// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3cdI5","subhead":"style_subhead__2HUWj","big":"style_big__2ShmH","anchored":"style_anchored__WBXm-"};